var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResearchFormMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 38,
    viewBox: "0 0 20 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2622 0.912842C18.6478 0.912842 19.7637 2.02831 19.7637 3.41431V35.0976C19.7637 36.4833 18.6482 37.5991 17.2622 37.5991H3.08808C1.70245 37.5991 0.586615 36.4836 0.586615 35.0976V3.41431C0.586615 2.02868 1.70208 0.912842 3.08808 0.912842H17.2622ZM12.6763 2.58024H7.67375C7.44344 2.58024 7.25675 2.76693 7.25675 2.99724C7.25675 3.22756 7.44344 3.41425 7.67375 3.41425H12.6763C12.9066 3.41425 13.0933 3.22756 13.0933 2.99724C13.0933 2.76693 12.9066 2.58024 12.6763 2.58024ZM18.0959 5.0817H2.25423V31.7624H18.0959V5.0817ZM10.1751 33.43C9.48443 33.43 8.92434 33.99 8.92434 34.6807C8.92434 35.3713 9.48441 35.9314 10.1751 35.9314C10.8657 35.9314 11.4258 35.3716 11.4258 34.6807C11.4258 33.99 10.8657 33.43 10.1751 33.43Z",
    fill: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchFormMobile);
export default __webpack_public_path__ + "static/media/research-form-mobile.2aaf6cc25f3b6d59fdc1cb2030920a52.svg";
export { ForwardRef as ReactComponent };